import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Box, List, ListItemButton, TextField} from 'views/components';

import _ from 'lodash';

const FilterOptions = (props) => {
  const [searchText, setSearchText] = React.useState('');

  const {
    filter,
    onClick,
  } = props;

  const options = filter.options;

  React.useEffect(() => {
    setSearchText('');
  }, [filter.key]);

  if (_.isEmpty(options)) {
    return null;
  }

  const normalizedSearchText = searchText.trim().toLowerCase();
  const sortedFilter = Object.values(options).filter((option) => {
    if (!filter.searchable || !normalizedSearchText) return true;
    return String(option.label || '').toLowerCase().includes(normalizedSearchText);
  }).sort((a, b) => {
    const rankA = a.rank;
    const rankB = b.rank;

    // Both items have a rank, compare by rank
    if (rankA !== undefined && rankB !== undefined) {
      return rankA - rankB;
    }

    // Only one item has a rank
    if (rankA !== undefined) return -1;
    if (rankB !== undefined) return 1;

    // Neither item has a rank, maintain original order
    return 0;
  });

  return (
    <Box sx={{pointerEvents: 'auto', p: 1}}>
      <Box>
        <Typography sx={{fontWeight: 'bold'}}>
          {filter.label}
        </Typography>
        {
          filter.searchable &&
          <TextField
            autoFocus
            fullWidth
            size="small"
            placeholder={filter.label}
            value={searchText}
            onChange={setSearchText}
            onKeyDown={(event) => event.stopPropagation()}
            sx={{mt: 1}}
          />
        }
        <List sx={{pb: 0}}>
          {
            sortedFilter.map((option, index) => {
              return (
                <ListItemButton key={index} onClick={() => onClick(filter, option)}>
                  {option.label}
                </ListItemButton>
              );
            })
          }
        </List>
      </Box>
    </Box>
  );
};
FilterOptions.propTypes = {
  filter: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default React.memo(FilterOptions);
